import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FormTypeDto } from '../../commons/dtos/form-type.dto';
import CustomTable from '../../components/CustomTable';
import { ICustomTableCellProps } from '../../components/CustomTableCell/interfaces';
import Paper from '../../components/Paper';
import FormService from '../../services/form.service';
import tableColumnMetadata from './table.metadta';

const formService = new FormService();

const ReportForm = () => {
  const [formTypes, setFormTypes] = useState<FormTypeDto[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchFormTypes = async () => {
      setLoading(true);

      const response = await formService.listFormTypes();

      setFormTypes(response.data);
      setLoading(false);
    };

    fetchFormTypes();
  }, []);

  const handleExportClick: ICustomTableCellProps<FormTypeDto>['onClick'] = async (item) => {
    await formService.exportFormTypeResponses(item.uniqueCode);
  };

  return (
    <Paper>
      <Row className="mb-2">
        <Col className="d-flex m-auto">
          <span>Reporte de Formularios</span>
        </Col>
      </Row>
      <Row className="mt-1">
        <Col>
          <CustomTable<FormTypeDto>
            data={formTypes}
            loading={loading}
            columnsMetadata={tableColumnMetadata}
            onActionClick={handleExportClick}
          />
        </Col>
      </Row>
    </Paper>
  );
};

export default ReportForm;
